import { LoadingState } from "~/common/components";
import AudioPlayer from "~/patients/components/ui/AudioPlayer";
import { ZOOM_RECORDING_STATUS } from "~/providers/constants/zoomRecordingStatus";
import { ZoomRecordingStatus } from "~/providers/utils/types/zoomMeetingTypes";

interface SessionRecordingPlayerProps {
  recordingStatus?: ZoomRecordingStatus | null;
  presignedUrl?: string;
  isLoadingRecording?: boolean;
}

const recordingStatusMessages: Record<ZoomRecordingStatus, string> = {
  IN_PROGRESS: "Recording is being processed. This may take a few minutes.",
  COMPLETED: "",
  FAILED: "No recording is available for this session.",
};

export const SessionRecordingPlayer = ({
  recordingStatus,
  presignedUrl,
  isLoadingRecording = false,
}: SessionRecordingPlayerProps) => {
  if (
    isLoadingRecording ||
    recordingStatus === ZOOM_RECORDING_STATUS.in_progress
  ) {
    return (
      <div className="flex items-center justify-center rounded-md border border-gray-200 p-3">
        <LoadingState />
      </div>
    );
  }

  if (
    !recordingStatus ||
    recordingStatus === ZOOM_RECORDING_STATUS.failed ||
    !presignedUrl
  ) {
    return (
      <div className="rounded-md bg-red-50 px-4 py-3 text-sm text-red-600">
        {recordingStatusMessages.FAILED}
      </div>
    );
  }

  return (
    <div className="rounded-md border border-gray-200 p-3">
      <AudioPlayer
        src={presignedUrl}
        totalDuration={0}
        className="w-full border-0 p-0"
      />
    </div>
  );
};
